"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BooleanQuestion;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _useQuestionAnswer = require("../../hooks/use-question-answer");

var _useQuestionAnswer2 = _interopRequireDefault(_useQuestionAnswer);

var _Radio = require("@material-ui/core/Radio");

var _Radio2 = _interopRequireDefault(_Radio);

var _Button = require("@material-ui/core/Button");

var _Button2 = _interopRequireDefault(_Button);

var _QuestionContainer = require("../QuestionContainer");

var _QuestionContainer2 = _interopRequireDefault(_QuestionContainer);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _QuestionText = require("../QuestionText");

var _QuestionText2 = _interopRequireDefault(_QuestionText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Row = _styledComponents2.default.div`
  display: flex;
  align-items: center;
`;
const AnswerContainer = (0, _styledComponents2.default)(_Button2.default)`
  && {
    padding: 0;
    padding-right: 20px;
    text-transform: none;
  }
`;

function BooleanQuestion({
  question,
  onChangeAnswer
}) {
  const [{
    answer,
    error
  }, changeAnswer] = (0, _useQuestionAnswer2.default)(question, onChangeAnswer);
  return _react2.default.createElement(_QuestionContainer2.default, {
    error: error,
    question: question,
    answered: answer !== undefined
  }, _react2.default.createElement(Row, null, _react2.default.createElement(AnswerContainer, {
    onClick: () => changeAnswer(true),
    style: {
      marginRight: 20
    },
    role: "button"
  }, _react2.default.createElement(_Radio2.default, {
    checked: answer === true
  }), _react2.default.createElement(_QuestionText2.default, null, "Yes")), _react2.default.createElement(AnswerContainer, {
    role: "button",
    onClick: () => changeAnswer(false)
  }, _react2.default.createElement(_Radio2.default, {
    checked: answer === false
  }), _react2.default.createElement(_QuestionText2.default, null, "No"))));
}